<template>
  <div class="modal-form-product">
    <div class="modal-form-product__icon">
      <img :src="baseUrl + product.thumbnail" class="modal-form-product__img">
    </div>
    <div class="modal-form-product__content">
      <div class="modal-form-product__name">
        {{ product.name }}
      </div>

      <div class="modal-form-product__price-area">
        <div class="modal-form-product__price">{{ formatNumberWithSpaces(product.price.toFixed(0)) }} руб.</div>
        <div v-if="product.profit" class="modal-form-product__price-raw">{{
          formatNumberWithSpaces(product.price_raw.toFixed(0)) }} руб.</div>
      </div>

    </div>

  </div>
</template>


<script>
import UtilsMixin from '../vue_mixins/UtilsMixin.vue';
import { settings } from '../variables'


export default {

  name: 'ProductSimple',

  mixins: [UtilsMixin],

  components: {

  },

  props: {
    product: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      baseUrl: settings.apiBaseUrl
    }
  },

  mounted() {

  },

  methods: {

  },

}
</script>


<style lang="scss"></style>
